import { MenuIcon } from './Icons';

export default function Header({
  onHome,
  onOpenAuth,
  onToast,
  mobileOpen,
  setMobileOpen,
  user,
}) {
  const openAuth = (mode) => {
    setMobileOpen(false);
    onOpenAuth(mode);
  };

  return (
    <header className="header">
      <div className="wrap header-top">
        <button className="logo" onClick={onHome} aria-label="Kaya Serene Villa home">
          Kaya Serene Villa
        </button>
        <div className="header-actions">
          {user ? (
            <button className="gold-btn hide-mobile" onClick={() => onToast(`Signed in as ${user}`)}>
              {user.split('@')[0]}
            </button>
          ) : (
            <>
              <button className="ghost-btn hide-mobile" onClick={() => openAuth('register')}>
                Register
              </button>
              <button className="gold-btn hide-mobile" onClick={() => openAuth('signin')}>
                Sign in
              </button>
            </>
          )}
          <button
            className="icon-btn menu-btn"
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <MenuIcon />
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="wrap mobile-only">
          {user ? (
            <button className="gold-btn" onClick={() => onToast(`Signed in as ${user}`)}>
              {user.split('@')[0]}
            </button>
          ) : (
            <>
              <button className="ghost-btn" onClick={() => openAuth('register')}>Register</button>
              <button className="gold-btn" onClick={() => openAuth('signin')}>Sign in</button>
            </>
          )}
        </div>
      )}
    </header>
  );
}
